export type MilestoneAge = 'stone';

export interface Milestone {
  id: string;
  name: string;
  age: MilestoneAge;
  // A milestone is satisfied if EVERY id here appears in some recruited
  // hero's contributions list.
  requires: ReadonlyArray<string>;
  blurb: string;
}

export const STONE_AGE_MILESTONES: ReadonlyArray<Milestone> = [
  {
    id: 'walk-upright',
    name: 'Walking Upright',
    age: 'stone',
    requires: ['bipedalism'],
    blurb: 'Two feet for the long savanna.',
  },
  {
    id: 'forage-the-land',
    name: 'Foraging the Land',
    age: 'stone',
    requires: ['foraging'],
    blurb: 'Fruit, tubers, eggs, marrow.',
  },
  {
    id: 'taming-fire',
    name: 'Taming Fire',
    age: 'stone',
    requires: ['fire'],
    blurb: 'A hearth pushed back the dark.',
  },
  {
    id: 'stone-tools',
    name: 'Stone Tools',
    age: 'stone',
    requires: ['hand-axe'],
    blurb: 'Edged flint, knapped by hand.',
  },
  {
    id: 'group-hunt',
    name: 'Group Hunting',
    age: 'stone',
    requires: ['hunting'],
    blurb: 'Spear, trap, and the shared chase.',
  },
  {
    id: 'first-metals',
    name: 'First Metals',
    age: 'stone',
    requires: ['metal-use'],
    blurb: 'Copper hammered cold; the Bronze Age beckons.',
  },
  {
    id: 'symbolic-mind',
    name: 'Symbolic Mind',
    age: 'stone',
    requires: ['symbolic-thought'],
    blurb: 'Marks for the dead, ochre for the living.',
  },
  {
    id: 'first-art',
    name: 'First Art',
    age: 'stone',
    requires: ['cave-art'],
    blurb: 'Hands and beasts painted under torchlight.',
  },
];

// To advance Stone → Bronze, the recruited party's contributions must
// cover all of these ids.
export const STONE_TO_BRONZE_GATE: ReadonlyArray<string> = ['fire', 'hand-axe', 'metal-use'];
